const baseURL = process.env.REACT_APP_BASE_URL;
export const importVesselTemplateDownloadUrl = `${baseURL}api/Templates/Vessels`;
export const importAdvantageVesselTemplateDownload = `${baseURL}api/Templates/AdvantageVesselTemplate`;
export const importReportTemplateInstructions = `${baseURL}api/Templates/ReportsInstructions`;

export const importReportDownloadTemplate = `${baseURL}api/Templates/Reports`;

export const importErpReportTemplateInstructions = `${baseURL}api/Templates/ReportsErpInstructions`;

export const importErpReportDownloadTemplate = `${baseURL}api/Templates/ErpReports`;

export const acceptExcelFormat =
	".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

export const importFuelEUReportDownloadTemplate = `${baseURL}api/Templates/FuelEuReports`;

export const importFuelEUReportTemplateInstructions = `${baseURL}api/Templates/ReportsFuelEuInstructions`;
export const exportThetis = `${baseURL}api/Report/GenerateThetisXml?reportMstId=`
export const euMrvDebug = `${baseURL}api/Report/GetExtendedEuMrv?reportMstId=`
export const importAdvantageUnifiedReportDownloadTemplate = `${baseURL}api/Templates/AdvantageUnifiedReports`;
export const importAdvantageUnifiedReportTemplateInstructions = `${baseURL}api/Templates/ReportsAdvantageUnifiedInstructions`;